import { ICreative } from './creativeset/creative/creative';
import { ISize } from './dimension';

export interface IZipOrchestrationData {
    creativeId: string;
    creativesetId: string;
    localizationId: string;
    size: ISize;
    targetUrl: string;
    checksum: string;
}

export interface IZipOrchestrationResponse {
    correlationId: string;
    creatives: {
        adId: string;
        creativeId: string;
    }[];
}

export enum PublishStatus {
    Unknown = 'Unknown',
    Published = 'Published',
    NotPublished = 'NotPublished',
    Publishing = 'Publishing',
    PublishedError = 'PublishedError'
}

export interface IPublishInfo {
    creative: ICreative;
    loading: boolean;
    connectedCampaigns: ICampaignPublishInfo[];
}

export interface ICampaignPublishInfo {
    id: string;
    name: string;
    publishStatus: {
        failed: boolean;
        generated: boolean;
        status: PublishStatus;
        publishOptionsSupportHeavyVideo: boolean;
    };
    checksum?: string;
}

export interface ICampaignPublishStatusResponse {
    id: string;
    name: string;
    status: PublishStatus;
    creatives: ICampaignCreative[];
}

export interface ICampaignCreative {
    checksum?: string;
    creativeId: string;
    creativeSetId: string;
    failed: boolean;
    generated: boolean;
    publishOptionsSupportHeavyVideo: boolean;
}
